import { useCallback, useEffect } from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import { useSetState } from 'utils/hooks/useSetState';

const tikuFirebaseConfig = {
  apiKey: process.env.REACT_APP_TIKU_API_KEY,
  authDomain: process.env.REACT_APP_TIKU_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_TIKU_DATABASE_URL,
  projectId: process.env.REACT_APP_TIKU_PROJECT_ID,
  storageBucket: process.env.REACT_APP_TIKU_STORAGE_BUCKET
};
export const useFirebase = (config = tikuFirebaseConfig) => {
  const [{ storage }, setState] = useSetState({
    storage: null
  });
  const initialize = useCallback(() => {
    let app;
    if (firebase.apps.length <= 0 || !firebase.app('tiku-hualien')) {
      app = firebase.initializeApp(config, 'tiku-hualien');
    } else {
      app = firebase.app('tiku-hualien');
    }
    app.auth().signInAnonymously()
      .then(() => {
        setState({ storage: app.storage() });
      })
      .catch(err => console.error('sign in anonymously error', err));
    setState({ storage: app.storage() });
  }, [config, setState]);

  useEffect(() => {
    if (!config) return;
    initialize();
  }, [config, initialize]);
  return { storage };
};
